import { usePage } from '@inertiajs/react'
import type { SharedProps } from './types'

// Typed access to Inertia shared props (auth, cart, flash, site, errors).
export function useShared(): SharedProps {
  return usePage<SharedProps>().props
}
